
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/briefs/create/[productKey]",
      function () {
        return require("private-next-pages/briefs/create/[productKey]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/briefs/create/[productKey]"])
      });
    }
  